<template>
  <div>
    <div class="text-center">
      <strong>{{ surveyQuestion() }}</strong>
    </div>
    <br />
    <div class="text-center">
      <base-button
        v-for="i in $store.state.main.game.surveyScale"
        :key="i"
        size="md"
        :aria-pressed="buttonPressed(i)"
        :type="getButtonType(i)"
        :class="getActiveClass(i)"
        :disabled="disableButtons"
        :style="'margin: 5px; cursor: ' + getCursorType() + '; ' + getPointerEventsStyle()"
        v-on:click="surveySelected(i)"
        >{{ i }}
      </base-button>
      <table width="100%" border="0">
        <tr>
          <td align="left">
            <small>1 = {{ getMinLabel }}</small>
          </td>
          <td align="right">
            <small
              >{{ getMaxLabel }} =
              {{ $store.state.main.game.surveyScale }}</small
            >
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { sendSurvey } from "../services/APIService";
import { getSurveyQuestion } from "../services/utils.js";

export default {
  props: ["survey", "selectedCaseNumber"],
  data: function () {
    return {
      answer: 0,
      buttonClicked: 0,
    };
  },
  computed: {
    getMinLabel() {
      const scenario = this.$store.getters.getScenarioInCurrentLocale;
      return this.survey === 1
        ? scenario.survey_question_1_minimum_value_label
        : scenario.survey_question_2_minimum_value_label;
    },
    getMaxLabel() {
      const scenario = this.$store.getters.getScenarioInCurrentLocale;
      return this.survey === 1
        ? scenario.survey_question_1_maximum_value_label
        : scenario.survey_question_2_maximum_value_label;
    },
    getScenario() {
      return this.$store.getters.getScenarioInCurrentLocale;
    },
    disableButtons() {
      if (this.$store.state.main.playerIsOnlyFacilitator || this.$store.state.main.playerIsObserver) {
        return true;
      } else {
        if (this.$store.state.main.game.surveyAnswersCanBeChanged) {
          return false;
        }

        // Let's disable the button right after the player has done a selection
        // (do not wait for vuex to update data), otherwise someone may double click the
        // button and backend may return 500 error.
        return this.answer || this.$store.getters.hasThisPlayerAnsweredSurvey(this.selectedCaseNumber, this.survey);
      }
    }
  },
  mounted() { },
  methods: {
    surveySelected(answer) {
      if (Date.now() - this.buttonClicked < 500) {
        return;
      }
      this.buttonClicked = Date.now();
      
      this.answer = answer;

      const aCase = this.$store.getters.getCaseByCaseNumber(
        this.selectedCaseNumber
      );
      sendSurvey(
        this.$store.state.main.game.id,
        this.$store.state.main.thisPlayerId,
        aCase.case,
        this.survey,
        this.answer,
        this.$store.state.main.game.gameCode
      ).then((resp) => {
        this.$store.dispatch("updateSurveyAnswersIfPolling");
      });
    },
    buttonPressed(buttonId) {
      return buttonId === this.answer;
    },
    getActiveClass(buttonId) {
      return this.buttonPressed(buttonId) ? "active" : "";
    },
    getButtonType(buttonId) {
      return this.buttonPressed(buttonId) ? "warning" : "primary";
    },
    surveyQuestion() {
      return getSurveyQuestion(
        this.survey,
        this.selectedCaseNumber,
        this.$store
      );
    },
    getCursorType() {
      if (this.$store.state.main.playerIsOnlyFacilitator || this.disableButtons) {
        return "initial"; // don't change cursor type in case only facilitator
      } else {
        return "auto";
      }
    },
    getPointerEventsStyle() {
      if (this.disableButtons) {
        return "pointer-events: none;"
      } else {
        return "";
      }
    },
  },
};
</script>
